// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React, { memo } from "react";

import { Alert } from "../Alert/Alert";
import { Button } from "../Button/Button";
import { Icons } from "../Icons/Icons";

import styles from "./Toast.module.css";

export const Toast = memo(
  ({ msg, showHeader = true, onClick, position = "top-right" }) => {
    const { id, timestamp, type, message, hidden } = msg;

    return (
      <div
        className={`${styles.toast_container} ${styles[`position_${position}`]}`}
        role="alert"
        aria-atomic="true"
        style={{
          borderLeft: `3px solid var(--color-${type})`,
          display: hidden ? "none" : "block",
        }}
        onClick={() => onClick(id, type)}
        data-testid="toast"
      >
        {showHeader && (
          <div className={styles.toast_header}>
            <p>
              {type}
              {id}
            </p>
            <div className={styles.header_control}>
              <p>{timestamp}</p>
              <Button
                onClick={() => onClick(id, type)}
                color="light"
                data-dismiss="toast"
                aria-label="Close"
              >
                <Icons iconType="close" />
              </Button>
            </div>
          </div>
        )}
        <Alert
          variant={type}
          message={<p className={styles.message_text}>{message}</p>}
        />
      </div>
    );
  },
);

Toast.displayName = "Toast";
